import cn from 'classnames';
import { SnowUnit } from 'components/blocks/Unit';
import { formatDateFromStr, formatShortDateStr } from 'util/formatDate';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { formatAsTodYestTomWeekday } from 'util/formatAgo';
import styles from './styles.module.scss';

export const SnowCardTh = (
  { date } : { snow: number, date: string },
) => (
  <th className={styles.cellDate} scope="col">
    <time dateTime={formatDateFromStr(date, 'yyyy-MM-dd')} className={styles.date}>{formatShortDateStr(date)}</time>
  </th>
);

export const SnowCardTdSnow = (
  { snow, isMetricUnits } : { snow: number, date: string, isMetricUnits?: boolean },
) => (
  <td className={styles.cellSnow}>
    <div className={cn(styles.snow, { [styles.metric]: isMetricUnits })}><SnowUnit values={snow} /></div>
  </td>
);

export const SnowCardTdDate = (
  { date } : { snow: number, date: string },
) => {
  const { t } = useOTSTranslation('common');

  return (
    <td className={styles.cellDay}>
      <div className={styles.day}>{formatAsTodYestTomWeekday(date, t)}</div>
    </td>
  );
};
